import React, { useState, useEffect } from 'react';
import bookingService from '../../../../../../services/booking.service';
import { useEyeconxStore } from '../../../../../../store/eyeconxStore';
import { ClinicInfoPanel } from '../../info/clinicInfoParts';
import ClinicSettingsEmpty from '../../subparts/ClinicSettingsEmpty';
import ClinicSettingsListSkeleton from '../../subparts/ClinicSettingsListSkeleton';

const VisitReasonItem = ({ item }) => (
    <div className="clinic-settings-record-item">
        <span className="clinic-settings-record-item__avatar">
            <i className="bi bi-chat-left-text"></i>
        </span>
        <div className="clinic-settings-record-item__main">
            <h6 className="clinic-settings-record-item__title">{item?.reason}</h6>
            <p className="clinic-settings-record-item__meta mb-0">
                {item?.isDefault ? 'Default reason' : 'Custom reason'}
            </p>
        </div>
        <span className={`clinic-settings-status-pill ${item?.isActive ? 'is-open' : 'is-closed'}`}>
            {item?.isActive ? 'Active' : 'Inactive'}
        </span>
    </div>
);

const VisitReasonCard = ({ onManage }) => {
    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const [visitReasons, setVisitReasons] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getVisitReasons();
    }, [clinicId]);

    const getVisitReasons = async () => {
        setIsLoading(true);
        try {
            const res = await bookingService.getAllVisitReasons(clinicId);
            setVisitReasons(res.data || []);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <ClinicInfoPanel title="Visit Reasons" icon="bi-chat-left-text">
                <ClinicSettingsListSkeleton rows={3} />
            </ClinicInfoPanel>
        );
    }

    return (
        <ClinicInfoPanel
            title="Visit Reasons"
            icon="bi-chat-left-text"
            actions={(
                <button type="button" className="btn btn-sm btn-light-primary rounded-pill" onClick={onManage}>
                    <i className="bi bi-sliders me-1"></i>
                    Manage
                </button>
            )}
        >
            {visitReasons.length === 0 ? (
                <ClinicSettingsEmpty
                    icon="bi-chat-left"
                    title="No visit reasons"
                    description="Configure visit reasons for online booking."
                    actionLabel="Manage Reasons"
                    onAction={onManage}
                />
            ) : (
                <div className="clinic-settings-record-list">
                    {visitReasons.map((reason, index) => (
                        <VisitReasonItem key={reason.id || index} item={reason} />
                    ))}
                </div>
            )}
        </ClinicInfoPanel>
    );
};

export default VisitReasonCard;
